import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Chip from "@material-ui/core/Chip";
import Autocomplete from "@material-ui/lab/Autocomplete";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputAdornment from "@material-ui/core/InputAdornment";
import A_FormHelper from "../../DataDisplay/Tooltips/A_FormHelper";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      width: theme.spacing(1),
    },
    marginTop: 5,
  },
  chip: {
    margin: theme.spacing(0.25),
  },
}));

export default function A_MultiselectWithSearch(props) {
  const {
    id,
    options = [],
    defaultValue = "",
    onChange = () => {},
    label = "",
    placeholder = "",
    disabled = false,
    limitTags = 3,
    noOptionsText = "No options",
    fieldHelperText,
    required = false,
    helperText,
    error = false,
    variant = "standard",
  } = props;

  const classes = useStyles();

  const selectedValues = React.useMemo(() => {
    if (!defaultValue) return [];
    try {
      return JSON.parse(defaultValue);
    } catch (e) {
      return [];
    }
  }, [defaultValue]);

  const handleChange = (event, newValue) => {
    const newValueString = JSON.stringify(newValue);
    onChange(newValueString, id);
  };

  return (
    <FormControl
      className={classes.root}
      error={error}
      required={required}
      fullWidth
    >
      <Autocomplete
        multiple
        options={options}
        value={selectedValues}
        onChange={handleChange}
        disableCloseOnSelect
        getOptionLabel={(opt) => opt.label || opt.value}
        getOptionSelected={(option, value) => option.value === value.value}
        filterSelectedOptions
        limitTags={limitTags}
        disabled={disabled}
        noOptionsText={noOptionsText}
        renderTags={(tagValue, getTagProps) =>
          tagValue.map((option, index) => (
            <Chip
              key={option.value}
              size="small"
              label={option.label || option.value}
              {...getTagProps({ index })}
              className={classes.chip}
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant={variant}
            label={label}
            placeholder={placeholder}
            required={required}
            error={error}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <InputAdornment position="end">
                  {fieldHelperText && (
                    <A_FormHelper fieldHelperText={fieldHelperText} />
                  )}
                  {params.InputProps.endAdornment}
                </InputAdornment>
              ),
            }}
          />
        )}
      />
      <FormHelperText>
        {error
          ? helperText || "This field is required"
          : fieldHelperText || helperText || ""}
      </FormHelperText>
    </FormControl>
  );
}

A_MultiselectWithSearch.propTypes = {
  id: PropTypes.any,
  options: PropTypes.array,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  limitTags: PropTypes.number,
  noOptionsText: PropTypes.string,
  fieldHelperText: PropTypes.string,
  required: PropTypes.bool,
  helperText: PropTypes.string,
  error: PropTypes.bool,
  variant: PropTypes.oneOf(["standard", "filled", "outlined"]),
};
